import React, { Component } from 'react'
import { pathOr } from 'ramda'
import { OnboardingHeader } from 'components/OnboardingHeader'
import { Button, Input } from '@drifthq/tide-core'
import PropTypes from 'prop-types'
import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'
import BackButton from 'components/OnboardingBackButton'
import { DisabledButton } from 'components/OnboardingDisabledButton'

import './style.css'

const beginsWithVowel = (key) => (
  key.match(/^[aieouAIEOU].*/)
)

const DISABLED_TOOLTIP_TEXT = (keyList) => (
  <div>Please enter a{!!beginsWithVowel(keyList[0]) && 'n'} {keyList[0]}<br />{pathOr('', [1], keyList)} before proceeding</div>
)

class DemoRequestStep extends Component {

  static propTypes = {
    index: PropTypes.number.isRequired,
    stepCount: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired,
    stepObject: PropTypes.object.isRequired,
    inputValue: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired,
  }

  render() {
    const { index, stepCount, onContinue, stepObject, botPreview, inputValue, handleInputChange, handleSave } = this.props
    const { title, key, placeholderDefault } = stepObject
    const keyList = key.split(' ')
    return <div className="demo-request-container">
      <div className="demo-request-input-wrapper">
        <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1} />
        <OnboardingHeader title={title} />
        <Input value={inputValue} className="demo-request-input" onChange={handleInputChange} placeholder={placeholderDefault} />
        {inputValue === "" ? <DisabledButton toolTipText={DISABLED_TOOLTIP_TEXT(keyList)} /> :
          <Button onClick={() => {
            handleSave()
            onContinue()
          }} className="demo-request-next-button" size="large">
            Next
            </Button>}
        <BackButton />
      </div>
      <div className="demo-request-preview-wrapper">{botPreview}</div>
    </div>
  }
}

export default DemoRequestStep


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookDemoRequestStep/component/index.js